import React from 'react';
import { useFrontload } from 'react-frontload';
import { RouteComponentProps } from 'react-router';
import Loading from '../../components/loading/loading';
import { apiV1 } from '../../lib/api';
import { BestOfYearLakePage } from './best_of_year_lake_page';

/* BEWARE HARD CODED FETCHING BELOW */
const BestOfYearLakePageContainer = (props: RouteComponentProps<{ slug: string }>) => {
  const { match } = props;
  const { slug } = match.params;

  const { frontloadMeta, data } = useFrontload(`BestOfYearLakePageContainer:${slug}`, async () => {
    const res = await apiV1.bestOfYearLakeFetch(2023, slug);

    return {
      best_of_lake: res.data.data,
    };
  });
  if (frontloadMeta.pending) {
    return <Loading text="Loading 2023 data" />;
  }

  return <BestOfYearLakePage best_of_lake={data.best_of_lake} />;
};

export default BestOfYearLakePageContainer;
